export enum LoadLayoutFaultsOptions {
  None = 0,
  EnsureVisibleAfterLoad = 1
}
